<template>
  <div class="sd-address-search address-search__expended" >
    <div class="search-input-box">
      <input v-model="searchText_"  v-on:keyup.enter="searchFirstData" v-on:keydown="handleKeyDown" @input="handleTextInput" placeholder="输入搜索地址" />
      <svg-icon class="clickable sd-hover" style="margin-right:10px;margin-top: 2px;width:25px;height:25px;" icon-class="search" @click="searchFirstData" title="搜索"></svg-icon>
    </div>
    
    <ul class="sd-address-search__suggest result-panel" v-show=" suggestList_ && suggestList_.length > 0">
      <li v-for="(item,index) in suggestList_" :key="index" :title="item.name" @click="handleClickSuggest(item)">
        <i  style="margin-left:5px;margin-top:3px;" class="el-icon-search" />
        <span style="margin-left:5px;" v-html="getText(item.name)" />
        <span class="text-address">{{ item.address }}</span> 
      </li>
    </ul>
    <div class="result-panel" v-show="queryList_ && queryList_.length > 0">
      <div class="query-statistic">
        <span>为您搜索到 <strong style="color: #409eff;">{{" "+queryCount_+" "}}</strong>条记录</span>
        <div>
          <span class="clickable sd-hover"  @click="clearInput">清除</span>
          <el-divider direction="vertical"></el-divider>
          <span class="clickable sd-hover"  @click="queryExpend_=!queryExpend_" >{{queryExpend_?'展开':'关闭'}}</span>
        </div>
        
      </div>
      <ul class="sd-address-search__query" :class="{'query-list__expended':queryExpend_}">
        <li v-for="(item,index) in queryList_" :key="index" 
        :class="{'hightlight-row':lightRowIndexs_.includes(index)}"
        @click="handleSelectPoi(item)" 
        @mouseenter="poiTips_= item"
        @mouseleave="poiTips_= null"
        >
          <svg-icon :icon-class="lightRowIndexs_.includes(index)?'position-red':'position-blue'" style="margin: 5px 0 0 5px;width: 25px;height: 25px;" />
          <div class="query-index-text" :class="{'query-index-hightlight':lightRowIndexs_.includes(index),'query-index-one':index<9,'query-index-two':index>=9&&index<99}">{{ index + 1 }}</div>
          <div class="query-info">

          <div :title="item.name">{{ item.name }}</div>
          <div :title="item.address" style="font-size:14px; color: #999;">地址：{{ item.address }}</div>
          </div>
        </li>
      </ul>
      <el-pagination 
        v-show="!queryExpend_" 
        :page-size="querySize_" 
        :pager-count="11" 
        layout="prev, pager, next" 
        :total="queryCount_" 
        small 
        hide-on-single-page
        style="margin:5px;"
        :current-page.sync="currentPage_"
        @current-change="handlePageChanged"  />
    </div>
  </div>
</template>

<script>
import {CoreMap} from '@/components/OlMap/Utils/CoreMap';
import {TEMPLATE_LAYER_INDEX}from '@/components/Constants/LayerIndex'
import TiandituAddressSearchServer from '@/components/OlMap/AddressSearch/TiandituAddressSearchServer'

import { Style,Icon,Fill,Stroke,Text} from 'ol/style.js';
import Feature from 'ol/Feature';
import { Point } from "ol/geom";
import { Select } from 'ol/interaction';

const HightlightStyle=(feature)=>{
  const style = new Style({
    image:new Icon({
      src: require('@/assets/images/positionr.png'),
      anchor: [0.5, 0],
      anchorOrigin: 'bottom-left',
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      scale: 1,
    }),
    text: new Text({
      font:'12px sans-serif',
      text: (feature.getId() + 1).toString(),
      fill: new Fill({
        color: '#fff'
      }),
      stroke: new Stroke({
        color: '#d81e06 ',
        width: 2
      }),
      offsetY: -15
    })
  })
  return style
}
export default {
  name: 'SdAddressSearch',
  props:{
    offset:{
      type:Number,
      default:0
    }
  },
  data() {
    return {
      map_:null,
      searchServer:null,
      suggestList_:[],
      suggestTimer_:null,
      searchText_:'',
      queryList_:[],
      queryCount_:0,
      querySize_:10,
      currentPage_:0,
      lightRowIndexs_:[],
      selectDriver_:null,
      selectPoi:null,
      poiLayer_:null,
      poiTips_:null,
      queryExpend_:false,
    };
  },

  mounted() {
    if (!this.map_ && this.$parent.map_) {
      this.setMap(this.$parent.map_,this.$parent)
    }
    this.searchServer = new TiandituAddressSearchServer()
  },
  beforeDestroy(){
    if (this.map_) {
      this.poiLayer_?this.map_.removeLayer(this.poiLayer_):null
      this.selectDriver_?this.map_.removeInteraction(this.selectDriver_):null
    }
  },

  methods: {
    setMap(map){
      this.map_ = map;
      this.projection_ = map.getView().getProjection().getCode()
      this.poiLayer_ = CoreMap.getVectorLayer({
        zIndex:TEMPLATE_LAYER_INDEX,
        style: (feature)=>{ 
          const style = new Style({
            image:new Icon({
              src: require('@/assets/images/position.png'),
              anchor: [0.5, 0],
              anchorOrigin: 'bottom-left',
              anchorXUnits: 'fraction',
              anchorYUnits: 'pixels',
              scale: 1,
            }),
            text: new Text({
              font:'12px sans-serif',
              text: (feature.getId() + 1).toString(),
              fill: new Fill({
                color: '#fff'
              }),
              stroke: new Stroke({
                color: '#1296db',
                width: 2
              }),
              offsetY: -15
            })
          })
          return style
        }
      })
      this.poiLayer_.name = "templatePoiLayer"
      this.selectDriver_ = new Select({
        layers:[this.poiLayer_],
        style:HightlightStyle,
        multi:true,
        hitTolerance:5
      })
      this.map_.addLayer(this.poiLayer_)
      this.map_.addInteraction(this.selectDriver_)
      this.selectDriver_.on('select',(e)=>{
        const features = e.target.getFeatures()
        this.lightRowIndexs_=[]
        if (features) {
          features.forEach(it=>{
            this.lightRowIndexs_.push(it.getId())
          })
        }
      })
    },
    handleClickSuggest(item){
      this.searchText_ = item.name
      this.suggestList_ = []
      this.searchFirstData()
    },
    handlePageChanged(pageIndex){
      this.search(pageIndex)
    },
    handleSelectPoi(poi){
      const feature =poi.feature
      if (feature) {
        this.lightRowIndexs_=[feature.getId()]
        this.selectDriver_.getFeatures().clear()
        this.selectDriver_.getFeatures().push(feature)
      }
      this.moveToPoint(poi.point,{flush:true})
      this.selectPoi = poi
      this.$emit('select-poi',poi)
    },
    handleTextInput(){
      this.handleSuggestion()
    },
    handleKeyDown(evt){
      if ((evt.altKey || evt.ctrlKey) && evt.keyCode===65) {
        evt.target.select()
      }
    },
    handleSuggestion(){
      if (this.suggestTimer_) {
        clearTimeout(this.suggestTimer_)
        this.suggestTimer_ = null
      }
      if (this.searchText_) {
        this.suggestTimer_ = setTimeout(this.getSuggests,1000)
      }else{
        this.clearInput()
      }
      
    },
    searchFirstData(){
      this.currentPage_=1
      this.search()
    },
    search(pageIndex=1){
      this.lightRowIndexs_=[]
      if (this.suggestTimer_) {
        clearTimeout(this.suggestTimer_)
        this.suggestTimer_ = null
      }
      this.suggestList_=[]
      //获取搜索结果
      if (!this.searchServer) {
        return  
      }
      const props = this.getDefaultSearchProps()
      props.count = this.querySize_
      props.page = pageIndex
      props.start = (pageIndex-1) * this.querySize_
      this.searchServer.query(props).then(res=>{
        if (res.list) {
          this.queryCount_ = Number( res.count)||0
          this.queryList_ = res.list || []
          this.refreshPoiLayer()
        }else{
          const {extent} = res
          extent && CoreMap.zoom(extent,this.map_)
        }
        
      })
      
    },
    clearInput(){
      this.searchText_ = ''
      this.suggestList_ = []
      this.queryList_ = []
      this.queryCount_ = 0
      this.searchReg_ = null
      this.poiLayer_?.getSource().clear()
    },
    getSuggests(){
      this.suggestTimer_ = null
      //获取搜索建议值
      if (!this.searchServer || !this.searchText_) {
        this.suggestList_ = []
        this.searchReg_ = null
        return
      }
      this.searchReg_ = new RegExp(this.searchText_,'g')
      
      const props = this.getDefaultSearchProps()
      this.searchServer.suggests(props).then(list => {
        this.suggestList_ = list || []
      })
    },
    refreshPoiLayer(){
      //刷新图层中poi点位
      if (this.poiLayer_) {
        this.poiLayer_.getSource().clear()
        const features = []
        this.queryList_.forEach((item,index)=>{
          if (!item.point) {
            return
          }
          const feature = new Feature({geometry:new Point(item.point)})
          feature.setProperties(item)
          feature.setId(index)
          item.feature= feature
          features.push(feature)
        })
        this.poiLayer_.getSource().addFeatures(features)
        const extent = this.poiLayer_.getSource().getExtent()
        if (extent && extent[0]!==Infinity) {
          CoreMap.zoom(extent,this.map_)
        }
      }
    },
    moveToPoint (pt, propsData) {
      const map = this.map_
      if (!map || !pt) {
        return
      }
      let zoomPt = pt
      if(this.offset>0){
        const resolution = map.getView().getResolution()
        const offsetX = this.offset * resolution
        const x = pt[0] - offsetX
        zoomPt = [x,pt[1]] 
        console.log("offset",offsetX,zoomPt,pt);
      }
      const props = Object.assign({flushDuration: 3000, duration: 1000, maxZoom: null }, propsData)
      const maxZoom = props.maxZoom || map.getView().getZoom()
      map.getView().animate({
        center:zoomPt,
        duration: props.duration,
        maxZoom: maxZoom
      })
    },
    getDefaultSearchProps(){
      const props = {
        keyWord: this.searchText_,
      }
      if (this.map_) {
        const extent = CoreMap.getMapBound(this.map_,this.projection_)
        props.mapBound = extent.join(',')
        props.level=this.map_.getView().getZoom().toFixed(0)
      }
      return props
    },
    getText(text){
      return this.searchReg_?
      text.replace(this.searchReg_,'<strong style="color: #409eff;">$&</strong>'):
      text
    },
  },
};
</script>
<style scoped>
.sd-address-search{
  position: absolute;
  display: flex;
  font: 14px "FangSong_GB2312";
  background-color: #fff;
  height: 40px;
  width: 40px;
  border-radius: 40px;
  z-index: 10;
  border:2px solid #979797;
  box-shadow:  inset  0 0 7px #b2b2b2;
  opacity:1;
  transition: all 0.5s ease-in-out
}
/* .panel-operate{
  opacity:1 !important;
} */
.search-input-box{
  display: flex;
  margin: 5px 0 5px 20px;
  width: 100%;
}
.address-search__expended{
  width: 320px;
}
.sd-address-search:hover{
  opacity:1;
}
input {
  width: calc(100% - 16px);
  height:30px;
  padding: 0;
  border: none;
  outline:none;
}
.result-panel{
  position: absolute;
  top: 45px;
  left: 0px;
  width: 100%;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 0 7px 0 #717171;
  
}
.sd-address-search__suggest {
  max-height: 300px;
  padding: 5px 0;
  overflow: auto; 
  z-index: 50;
}
.sd-address-search__query{
  overflow: auto; 
  max-height: 75vh;
}
.sd-address-search__suggest::-webkit-scrollbar {
  display: none;
}

ul{
  margin: 0;
  padding: 0;
}
ul li{
  list-style-type:none;
  padding: 5px;
  overflow: hidden;
  text-overflow:ellipsis; 
  white-space: nowrap;
  cursor: pointer;
  border-radius: 5px;
  display: flex;
  position:relative
}

ul li:hover{
  background-color: #f5f5f5;
  
}
.sd-address-search__suggest .text-address{
  color: #999;
  font-size: 12px;
  margin-left: 10px;
}
.query-statistic{
  padding:10px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
}
.query-info{
  text-align:left;
  font-size: 16px;
  width: calc(100% - 35px);
}
li .query-info div{
  margin: 5px 5px 7px 5px;
  overflow: hidden;
  text-overflow:ellipsis; 
  white-space: nowrap;
}
.query-list__expended{
  height: 0;
}
.hightlight-row{
  background-color: #cbeaf9;
}
.goto-address{
  position:absolute;
  right:10px;
  top:10px;
  padding: 5px;
  transition:all 0.2s
}
.goto-address:hover{
  padding: 0 0 10px 10px;
}
.query-index-text{
  position:absolute;
  color:#fff;
  font-size: 12px;
  border-radius: 50%;
  
  background-color: #1296db;
}
.query-index-one{
  margin: 8px 11px;
  padding: 0px 3px;
}
.query-index-two{
  padding: 0px 0px;
  margin: 8px 10px;
}
.query-index-hightlight{
  background-color: #d81e06 !important;
}
</style>